<template>

    <div class="galaxy::common-canvas-editor-canvas-Tabs">

        <button v-for="tab in tabs"
                :key="tab"
                @click="tabSelected = tab"
                :class="['tab-btn', { active: tabSelected === tab }]"
        >
            {{ tab }}
        </button>

        <div class="tabs">

            <div class="tab" v-for="tab in tabs">
                <slot :name="tab" v-if="tabSelected === tab" />
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: {
            tabs: Array
        },

        data()
        {
            return {
                tabSelected: _.first(this.tabs),
            }
        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-Tabs {

        .tab-btn {
            padding: 6px 10px;
            cursor: pointer;
            border: none;
            outline: none;

            &.active {
                border-bottom: 2px solid #3899ec;
            }
        }

        .tab {
            //border-top: 1px solid #ccc;
        }

    }

</style>